<template>
  <div>
    <v-navigation-drawer v-model="$store.state.drawer.open" app>
      <v-list-item two-line v-if="username">
        <v-list-item-content>
          <v-list-item-subtitle>Logged in as:</v-list-item-subtitle>
          <v-list-item-title class="grey--text">{{
            username
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item-group>
          <v-list-item
            v-for="(link, i) in links"
            :key="i"
            router
            :to="link.route"
            link
            active-class="active-link-item"
          >
            <v-list-item-icon>
              <v-icon v-text="link.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="link.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <template v-slot:append>
        <v-list-item>
          <v-row>
            <v-col class="text-center">
              <v-btn text @click="logout">
                <span>Signout</span>
                <v-icon right>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: 'NavDrawer',

  data: () => ({
    links: [
      { icon: 'mdi-view-dashboard', title: 'Dashboard', route: '/' },
      { icon: 'mdi-account', title: 'Users', route: '/users' },
      { icon: 'mdi-account', title: 'Partners', route: '/partners' }
    ]
  }),

  methods: {
    logout() {
      sessionStorage.clear();
      this.$store.dispatch('auth/clearUserData');
      this.$router.push({ path: '/login' });
    }
  },

  computed: {
    username() {
      return sessionStorage.getItem('username');
    }
  }
};
</script>

<style>
.active-link-item {
  background-color: #004d40;
  color: #fff !important;
}
</style>
